import { render, staticRenderFns } from "./AddTaxObligationDocumentModal.vue?vue&type=template&id=120c2e97&"
import script from "./AddTaxObligationDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./AddTaxObligationDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports